import Navigate             from "Dashboard/Core/Navigate";
import Store                from "Dashboard/Core/Store";
import DateTime             from "Dashboard/Utils/DateTime";
import Utils                from "Dashboard/Utils/Utils";
import { Page }             from "Utils/API";



// The initial State
const initialState = {
    loading      : true,
    error        : false,
    edition      : 0,
    canCreate    : false,
    canEdit      : false,
    canFilter    : false,
    canImport    : false,
    canExport    : false,
    list         : [],
    total        : 0,
    elem         : {},
    statuses     : [],
    activitySlug : "",
    sort         : {
        orderBy  : "name",
        orderAsc : 0,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "PAGE_LOADING" });
    },

    /**
     * Fetches the Page List
     * @param {Function} dispatch
     * @param {String=}  type
     * @param {Number=}  elemID
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, type = "", elemID = 0, params = {}) {
        Navigate.unsetParams(params);
        if (type === "ACTIVITY") {
            params.activityID = elemID;
        }

        const data = await Page.getAll({ ...params });
        data.sort  = params;
        dispatch({ type : "PAGE_LIST", data });
    },

    /**
     * Fetches a single Page
     * @param {Function} dispatch
     * @param {Number}   pageID
     * @returns {Promise}
     */
    async fetchElem(dispatch, pageID) {
        const data = await Page.getOne({ pageID });
        dispatch({ type : "PAGE_ELEM", data });
        return data;
    },

    /**
     * Fetches the Page Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await Page.getEditData();
        dispatch({ type : "PAGE_EDIT", data });
    },

    /**
     * Edits/Creates a Page
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Page.edit(data);
    },

    /**
     * Deletes the Page
     * @param {Function} dispatch
     * @param {Number}   pageID
     * @returns {Promise}
     */
    deleteElem(dispatch, pageID) {
        return Page.delete({ pageID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.modifiedTimeDate = DateTime.formatDate(elem.publishTime, "dashesTime");
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "PAGE_LIST", "PAGE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "PAGE_LOADING":
        return {
            ...state,
            loading      : true,
        };

    case "PAGE_LIST":
        return {
            ...state,
            loading      : false,
            error        : false,
            canCreate    : action.data.canCreate,
            canEdit      : action.data.canEdit,
            canFilter    : action.data.canFilter,
            canImport    : action.data.canImport,
            canExport    : action.data.canExport,
            list         : Utils.parseList(action.data.list, parseElem),
            total        : action.data.total,
            sort         : action.data.sort,
        };

    case "PAGE_ELEM":
        return {
            ...state,
            error        : false,
            edition      : state.edition + 1,
            elem         : parseElem(action.data.elem),
            statuses     : action.data.statuses,
            activitySlug : action.data.activitySlug,
        };

    case "PAGE_EDIT":
        return {
            ...state,
            error        : false,
            edition      : state.edition + 1,
            statuses     : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
